import { render, staticRenderFns } from "./InvoicingInput.vue?vue&type=template&id=27ca038a&scoped=true&"
import script from "./InvoicingInput.vue?vue&type=script&lang=js&"
export * from "./InvoicingInput.vue?vue&type=script&lang=js&"
import style0 from "./InvoicingInput.vue?vue&type=style&index=0&id=27ca038a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ca038a",
  null
  
)

export default component.exports